import React from "react"
import styled from "styled-components"
import { FaQuoteLeft } from "react-icons/fa"

export default function CartRight() {
  return (
    <Wrapper>
      <FaQuoteLeft className="icon" />
      <h5>
        Agradece las cosas simples de la vida. No los des por sentado. Después
        de todo … ¿Qué daría un ciego para ver los agradables ríos, praderas,
        flores y fuentes? y esta y muchas otras bendiciones que disfrutamos
        diariamente
      </h5>
      <p>Izaak Walton.</p>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .icon {
    font-size: 3.5rem;
  }

  h4 {
    font-weight: 400;
  }
  p {
    color: var(--grey-700);
  }

  @media screen and (min-width: 768px) {
    width: 65%;
  }
  @media screen and (min-width: 992px) {
    padding-left: 6rem;
    border-width: 0 0 0 1px;
    border-style: solid;
    border-color: var(--primary-500);
  }
`
